export default "__VITE_ASSET__BIbFiqPC__"